import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface TablePageTitleProps {
  children: string;
}

export function TablePageTitle({ children }: TablePageTitleProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="xxl:max-w-[200px] max-w-[150px] truncate text-sm font-medium">{children}</div>
        </TooltipTrigger>
        <TooltipContent>{children}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
